<template>
  <div class="col-md-12">
    <div class="title-heading d-flex justify-content-between">
      <h1>{{ $static('s-mfilter.title', 'Меню') }}</h1>
    </div>
    <div class="panel">
      <div class="radio-group">
        <label style="margin-right: 30px;">
          <input type="radio" :value="undefined" v-model="setType">
          {{ $static('catalog-menu-filter.only-categories', 'Тільки категорії') }}
        </label>
        <label>
          <input type="radio" value="advanced" v-model="setType">
          {{ $static('catalog-menu-filter.cat-subcategories', 'Категорії і підкатегорії') }}
        </label>
      </div>

      <!--      <select v-model="setType">-->
      <!--        <option :value="undefined">Стандартний режим</option>-->
      <!--        <option value="advanced">Просунутий режим</option>-->
      <!--      </select>-->

      <div class="menu advanced catalog-menu-filter" v-if="setType === 'advanced'">
        <div class="breadcrumbs">
          <div class="bread" v-for="(item, index) in breadcrumbs" :key="index">
            <button @click="select(item)">
              {{ $dynamic(item, item.name, 'name') }}
            </button>
          </div>
        </div>

        <div class="high-level">
          <div class="category" v-for="(item, index) in advanced" :key="index">
            <button @click="select(item)" class="category-item">
              {{ $dynamic(item, item.name, 'name') }}
            </button>
            <div class="action-box">
              <button @click="delCategory(index)" class=" btn-icon  btn-icon-transparent btn-remove">
                <span class="icon icon-trash"></span>
              </button>
              <button @click="swap(advanced, index, index - 1)" class=" btn-icon  btn-icon-transparent">
                <span class="icon icon-left"></span>
              </button>
              <button @click="swap(advanced, index, index + 1)" class=" btn-icon  btn-icon-transparent">
                <span class="icon icon-right"></span>
              </button>
            </div>
          </div>

          <div class="category-selector">
            <v-select id="editor_category" :options="categoriesOptions" :reduce="c => c.value" v-model="addCategory">
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes">
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                      fill="#212121" />
                  </svg>
                </span>
              </template>
            </v-select>
          </div>
        </div>

        <div class="low-level mb-2 " v-if="selected">
          <h4>{{ selected.name }}</h4>
          <div class="category" v-for="(item, index) in selected.list" :key="index">
            <button @click="select(item)" class="category-item">
              {{ item.name }}
            </button>
            <div class="action-box">
              <button @click="delSubcategory(index)" class=" btn-icon  btn-icon-transparent btn-remove">
                <span class="icon icon-trash"></span>
              </button>
              <button @click="swap(selected.list, index, index - 1)" class=" btn-icon  btn-icon-transparent">
                <span class="icon icon-left"></span>
              </button>
              <button @click="swap(selected.list, index, index + 1)" class=" btn-icon  btn-icon-transparent">
                <span class="icon icon-right"></span>
              </button>
            </div>
          </div>

          <div class="category-selector">
            <v-select id="editor_category" :options="categoriesOptions" :reduce="c => c.value" v-model="addSubCategory">
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes">
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                      fill="#212121" />
                  </svg>
                </span>
              </template>
            </v-select>
          </div>
        </div>

        <div class="row" v-if="selected">
          <div class="col">
            <!--sizes-->
            <div class="panel panel-bordered">
              <div class="size-panel mb-1" v-for="(option, index) in optionsTags" :key="index">
                <h4>{{ option.option }}:</h4>
                <div class="size-checkbox-group">
                  <!--size checkbox-->
                  <div class="option-checkbox" v-for="(item, index) in option.list.sort((a, b) => a.order - b.order)"
                    :key="index">
                    <input :id="item.option_id + index" type="checkbox"
                      @change="selectOption('', -1, item.option_id, item.id)"
                      :checked="selectedOption('', -1, item.option_id, item.id) > -1" :value="item.id"
                      :name="option.option_id">

                    <label :for="item.option_id + index">{{ $dynamic(item, item.name, 'name') }}</label>
                  </div>
                  <!--end size checkbox-->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="groups.length">
          <div class="col">
            <div class="panel panel-bordered">
              <div class="size-panel mb-1" v-for="(g, gIndex) in groups" :key="gIndex">
                <div class="d-flex align-items-center mb-2">
                  <h4 class="mb-0" style="margin-right: 20px">{{ g.name }}:</h4>
                  <Popper arrow :content="$static('iconsbtn.delete', 'Видалити')" hover placement="right"
                    style="white-space: nowrap">
                    <button @click="removeGroup(gIndex)" class=" btn-icon btn-rounded btn-icon-transparent btn-remove">
                      <span class="icon icon-trash"></span>
                    </button>
                  </Popper>

                </div>
                <div class="size-checkbox-group">
                  <!--size checkbox-->
                  <div class="option-checkbox" v-for="(item, index) in optionsTags[0].list" :key="index">
                    <input :id="'gr-' + gIndex + index" type="checkbox"
                      @change="selectOption('groups', gIndex, 'list', item.id)"
                      :checked="selectedOption('groups', gIndex, 'list', item.id) > -1" :value="item.id"
                      :name="'gr-' + gIndex">

                    <label :for="'gr-' + gIndex + index">{{ item.name }}</label>
                  </div>
                  <!--end size checkbox-->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="selected_category">
          <div class="col">
            <div class="d-flex mt-2">
              <div class="form-group d-flex mb-0 align-items-center" style="margin-right: 30px;">
                <label class="custom-input" style="white-space: nowrap; margin-right: 20px">
                  {{ $static('catlog-menu-filter.new-group', 'Нова група') }}
                </label>
                <input type="text" class="form-control custom-input" v-model="newGroupName">

              </div>
              <button class="default-btn btn-with-icon btn-outline btn-outline-dark" @click="addNewGroup"><span
                  class="text">{{
                    $static('catlog-menu-filter.add-group', 'Додати групу') }}</span><span
                  class="icon icon-add"></span></button>
            </div>
          </div>
        </div>

      </div>
    </div>
    <button class=" default-btn btn-accent" @click="save">
      <span class="text">{{ $static('catlog-menu-filter.save', 'Зберегти') }}</span>
    </button>

  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'CatalogMenuFilter',
  components: {},
  data() {
    return {
      setType: undefined,
      template_id: undefined,
      selected: undefined,
      newGroupName: '',
      needSave: false,
      advanced: [],
      breadcrumbs: []
    }
  },
  mounted() {
    // if (!this.list.length) {
    //   this.getItems()
    // }

    this.getItems()

    if (this.settings?.public?.menu_type) {
      this.setType = this.settings.public.menu_type
    }
    if (this.setType) {
      this.fetchTemplate(this.setType)
    }
    // console.log('mount filter menu', this.list, this.setType, this.settings?.public?.menu_type)
  },
  computed: {
    optionsTags() {
      return this.$store.getters.options.filter(i => i.option_id === 'tags')
    },
    settings() {
      return this.$store.getters.settings
    },
    categories() {
      return this.$store.getters.options.filter(i => i.option_id === 'category')
    },
    groups() {
      return this.selected_category?.info?.groups ? this.selected_category.info.groups : []
    },
    selected_category() {
      return this.selected ? this.categories[0].list.find(x => x.id === this.selected.id) : this.selected
    },
    list() {
      return this.categories?.length ? this.categories[0].list.sort((a, b) => a.order - b.order) : []
    },
    categoriesOptions() {
      return this.list ? this.list.map(x => { return { label: x.name, value: x.id } }) : []
    },
    addCategory: {
      get() {
        return { label: this.$static('catlog-menu-filter.choose-category', 'Оберіть категорію'), value: undefined }
      },
      set(value) {
        if (this.advanced.find(x => x.id === value)) {
          return
        }
        let c = this.getCategory(value)
        this.advanced.push({ id: value, name: c.name, list: [], level: 0 })
      }
    },
    addSubCategory: {
      get() {
        return { label: this.$static('catlog-menu-filter.choose-category', 'Оберіть категорію'), value: undefined }
      },
      set(value) {
        if (this.selected.list.find(x => x.id === value)) {
          return
        }
        let c = this.getCategory(value)
        this.selected.list.push({ id: value, name: c.name, list: [], level: this.selected.level + 1 })
      }
    }
  },
  methods: {
    swap(arr, index1, index2) {
      if (index2 > arr.length - 1 || index2 < 0) {
        return
      }
      let temp = arr[index1];
      arr[index1] = arr[index2];
      arr[index2] = temp;
    },
    delCategory(index) {
      this.advanced.splice(index, 1)
      this.selected = undefined
    },
    delSubcategory(index) {
      this.selected.list.splice(index, 1)
    },
    async select(category) {
      if (this.needSave) {
        await this.saveCategory()
      }

      this.selected = category;
      if (category.level >= this.breadcrumbs.length) {
        this.breadcrumbs.push(category)
      } else {
        this.breadcrumbs[category.level] = category
        this.breadcrumbs = this.breadcrumbs.slice(0, category.level + 1)
      }
    },
    getCategory(id) {
      return this.list ? this.list.find(i => i.id === id) : {}
    },
    getItems() {
      api.get('/api/options').then(response => response.data).then(data => {
        this.$store.commit('setOptions', data)
      });

      api.get('/api/options/categories')
        .then(response => response.data)
        .then(data => {
          if (data.result) {
            this.category = data.result.find(i => i.option_id === 'category')
          }
          if (data.settings) {
            this.settings = data.settings
          }
        })
    },
    fetchTemplate(name) {
      if (this.loading) {
        return
      }
      this.loading = true;
      api.get('/api/template/' + name).then(response => response.data).then(data => {
        this[name] = data.settings;
        this.template_id = data.id;
        this.loading = false;
      }).catch(() => this.loading = false)
    },
    getSub(top) {
      let list = [top.id]
      if (top.list?.length) {
        top.list = top.list.map(this.getSub)
        list = list.concat(...top.list.map(x => x.search_by)).filter((value, index, array) => array.indexOf(value) === index);
      }
      top.search_by = list
      return top
    },
    menuPreProcess() {
      if (this.setType === 'advanced') {
        this.advanced.map(this.getSub)
        // console.log(this.advanced)
      }
    },
    selectOption(targetKey, targetIndex, key, value) {
      this.needSave = true;
      if (!this.selected_category.info) {
        this.selected_category.info = {};
      }
      let target = this.selected_category.info;
      if (targetKey) {
        target = target[targetKey];
      }
      if (targetIndex > -1) {
        target = target[targetIndex];
      }
      // console.log(target, key, target[key]);
      if (!target[key] || !Array.isArray(target[key])) {
        target[key] = [];
      }
      try {
        let idx = target[key].indexOf(value);
        if (idx === -1) {
          target[key].push(value);
        } else {
          target[key].splice(idx, 1);
        }
      } catch (e) {
        target[key] = [value];
      }
    },
    selectedOption(targetKey, targetIndex, key, value) {
      console.log(this.selected_category)
      if (!this.selected_category?.info) {
        this.selected_category.info = {}
      }
      let target = this.selected_category.info;
      if (targetKey) {
        target = target[targetKey]
      }
      if (targetIndex > -1) {
        target = target[targetIndex];
      }
      if (!Array.isArray(target[key])) {
        return -1;
      }
      return target && target[key] ? target[key].indexOf(value) : -1;
    },
    addNewGroup() {
      this.needSave = true;
      if (!this.selected_category.info) {
        this.selected_category.info = {};
      }
      if (!this.selected_category.info.groups) {
        this.selected_category.info.groups = [];
      }
      let name = this.newGroupName;
      this.selected_category.info.groups.push({ name: name, order: this.selected_category.info.groups.length, list: [], translate: {} });
      this.newGroupName = ''
    },
    removeGroup(index) {
      this.needSave = true
      this.selected_category.info.groups.splice(index, 1)
    },
    async saveCategory() {
      this.needSave = false
      await api.put('/api/options', this.selected_category)
        .then(response => response.data)
        .then(x => {
          console.log(x)
        })
    },
    async save() {
      this.menuPreProcess()
      // return
      if (this.needSave) {
        await this.saveCategory()
      }
      if (this.setType !== this.settings.public.menu_type) {
        let settings = Object.assign({}, this.settings)
        settings.public.menu_type = this.setType
        api.post('/api/settings', { settings: settings }).then(response => response.data).then(data => {
          if (data) {
            this.$store.commit('setSettings', data);
            this.$notify({
              title: this.$static('notify-menu-settings.title', 'Налаштування меню'),
              text: this.$static('notify.save', 'Збережено.'),
              duration: 3000
            });
          }
        })
      }
      if (this.setType) {
        let obj = { id: this.template_id, settings: this[this.setType], name: this.setType };
        // console.log(obj)
        api.post('/api/template', obj).then(response => response.data).then(() => {
          this.$notify({
            title: this.$static('notify-menu-info.title', 'Інформація меню'),
            text: this.$static('notify.save', 'Збережено.'),
            duration: 3000
          });

          let menu = Object.assign(obj, { name: 'menu' });
          delete menu.id
          api.post('/api/template', menu).then(response => response.data).then(() => { })
        }).catch(error => {
          this.$notify({
            title: this.$static('notify-menu-info.title', 'Інформація меню'),
            text: this.$static('notify.save-error', 'Сталася помилка при збереженні.'),
            duration: 3000
          });
        })

      }

    }
  },
  watch: {
    settings(val) {
      this.setType = val.public.menu_type
      if (this.setType) {
        this.fetchTemplate(this.setType)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.catalog-menu-filter .breadcrumbs>div+div:before {
  content: "/";
  color: #ACACAC;
  padding: 0 10px;
}

.catalog-menu-filter {
  .category {
    position: relative;

    .action-box {
      position: absolute;
      right: 15px;
      top: 5px;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
    }

    .btn-icon {
      min-width: 40px;
      width: 40px;
      height: 40px;

      &.btn-icon-transparent {
        &:hover {
          background-color: #e7e7e7;
        }
      }

      &:hover {}

      .icon {}
    }

    .category-item {
      transition: all .05s cubic-bezier(.165, .84, .44, 1);
      -webkit-transition: all .05s cubic-bezier(.165, .84, .44, 1);
      border: none;
      position: relative;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-align-items: center;
      align-items: center;
      height: 50px;
      white-space: nowrap;
      padding: 0px 135px 0 30px;
      border-radius: 9px;
      -moz-border-radius: 9px;
      -webkit-border-radius: 9px;
      background-color: #f5f5f5;
      box-shadow: 0px 1px 2px rgba(33, 33, 33, 0.19999999999999995);
      font-weight: 500;
      margin-right: 10px;
      margin-bottom: 10px;
      //&:hover{
      //  background-color: #e1e0e0;
      //}


    }
  }

  .low-level {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    padding-top: 15px;
    margin-top: 10px;
    border-top: 1px solid #c8cfd9;

    .category {

      .category-item {
        background-color: transparent;
        box-shadow: none;
        border: 1px solid #eaeaea;
      }
    }

    h4 {
      width: 100%;
    }
  }

  .high-level {
    padding-top: 15px;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap;


  }

  .breadcrumbs {
    padding: 25px 0 0;
    margin-bottom: 5px;
    list-style: none;
    background-color: transparent;
    border-radius: 0;
    font-weight: 500;
    flex-wrap: nowrap;
    -webkit-flex-wrap: nowrap;
    margin-right: -15px;
    font-size: 14px;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    overflow-x: auto;

    button {
      font-family: 'FontsFree-Net-SFProDisplay-Medium', Arial, sans-serif;
      background-color: transparent;
      border: none;
      white-space: nowrap;
      box-shadow: none;
      padding: 0;
    }
  }
}
</style>